import { Image, Text, Box, Heading, Flex, Container } from "@chakra-ui/react"
import React from "react"
import { SharePost } from "../../../components/SharePost/sharePost";

export enum MAIN_CATEGORY_TILE_TYPE {
    TAG,
    CATEGORY,
}

const typeTitleOptions = {
    [MAIN_CATEGORY_TILE_TYPE.CATEGORY]: 'Kategoria główna',
    [MAIN_CATEGORY_TILE_TYPE.TAG]: 'Tag',
}

const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const MainCategoryTile = ({ category: { name, description, categoryConfig, category }, type = MAIN_CATEGORY_TILE_TYPE.CATEGORY }) => {
    return (
        <Box background="#EAF4FF" mb="28px" mx={{ base: "-15px", sm: "0" }} px={{ base: '15px', sm: '0' }}>
          <Flex gridGap="40px" py={{base: '14px', md: "34px"}} px={{base: '0', md: "60px"}} justifyContent="space-between" alignItems="center" >
              <Box>
                  <Text fontSize="14px">{typeTitleOptions[type]}</Text>
                  <Heading color="#222c63" mb="20px" fontSize="28px">{capitalizeFirstLetter(name)}</Heading>
                  {description && (<Text color="#252525" fontSize="16px">{description}</Text>)}
              </Box>
              {categoryConfig?.logo && (<Image loading="lazy" d={{ base: 'none', sm: 'block' }} w={{base: '102px', md: '122px'}} src={categoryConfig?.logo?.sourceUrl} alt="" />)}
          </Flex>
          <Flex cursor="pointer" color="#636363" d={{base: 'flex', md: 'none'}} p="0 0 14px 0" >
            <SharePost link={typeof window !== "undefined" ? window.location.href : ''} title={name} d={{base: "block", md: "none"}} />
            <Text fontSize="10px">Podaj dalej</Text>
          </Flex>
        </Box>
    )
}
